import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  isEmptyVal,
  isNotEmpty,
  displayField,
  displayDateTimeField,
  displayDateField,
} from "../../../utils/helpers";

const MusicScheduleInfoCell = ({
  dataKey,
  rowData,
  onClick,
  ...props
}: {
  dataKey?: string;
  rowData: any;
  onClick?: Function;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  if (isEmptyVal(rowData.total_songs)) rowData.total_songs = 0;
  const speaker = (
    <Popover title={rowData.playlist_title}>
      <p>
        <b>{t("NAME")} : </b>
        {displayField(rowData.playlist_title)}
      </p>
      {rowData.is_default_playlist.toString() === "1" && (
        <p>
          <b>
            {t("DEFAULT")} {t("SCHEDULE")}{" "}
          </b>
        </p>
      )}
      <p>
        <b>{t("SONGS")} : </b>
        {displayField(rowData.total_songs)} {t("OUT_OF")}{" "}
        {displayField(parseInt(rowData.max_songs))}
      </p>
      <p>
        <b>
          {t("NEW")} {t("SCHEDULE")} {t("EVERYDAY")} :{" "}
        </b>
        {rowData.new_schedule_everyday.toString() === "1" ? t("YES") : t("NO")}
      </p>

      <p>
        <b>
          {t("DAY")} {t("PARTS")}:{" "}
        </b>
        {displayField(rowData.day_parts)}
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a
          onClick={() => {
            onClick && onClick(rowData);
          }}
        >
          {displayField(rowData.playlist_title)}{" "}
          {rowData.is_default_playlist.toString() === "1" && "(" + t("D") + ")"}
          <br />
          {rowData.total_songs} {t("SONGS")}
          <br />
          {rowData.is_default_playlist.toString() === "0" &&
            !isEmptyVal(rowData.play_start_date) &&
            " " +
              displayDateField(rowData.play_start_date) +
              " " +
              t("TO") +
              " " +
              displayDateField(rowData.play_end_date)}
        </a>
      </Whisper>
    </Cell>
  );
};

export default MusicScheduleInfoCell;
